/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  tableHeading: {
    fontSize: "12px",
    fontWeight: "bold",
    marginLeft: 10,
  },
  table: {
    border: "1px",
    margin: "10",
  },
  header: {
    fontWeight: "bold",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    fontSize: "9px",
  },
  row: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    flexDirection: "row",
  },
  cell: {
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: "9px",
  },
  lastCell: {
    borderRightWidth: 0,
  },
  headerItem: {
    fontWeight: "bold",
    width: "25%",
  },
  cellItem: {
    fontWeight: "normal",
    width: "25%",
  },
});

const PlayerRosterTable = ({ playerRoster }: any) => (
  <>
    <Text style={styles.tableHeading}>Player Roster</Text>
    <View style={styles.table}>
      <View style={[styles.row, styles.header]}>
        <Text style={[styles.cell, styles.headerItem, { width: "50%" }]}>Player Name</Text>
        <Text style={[styles.cell, styles.headerItem]}>Uniform No.</Text>
        <Text style={[styles.cell, styles.headerItem]}>Jersey Size</Text>
        <Text style={[styles.cell, styles.headerItem]}>Pant Size</Text>
        <Text style={[styles.cell, styles.headerItem]}>Helmet Size</Text>
        <Text style={[styles.cell, styles.lastCell, styles.headerItem]}>Inseam</Text>
      </View>
      {playerRoster &&
        playerRoster.map((row: any, index: number) => (
          <View key={index} style={styles.row}>
            <Text style={[styles.cell, styles.cellItem, { width: "50%" }]}>{row.playerName}</Text>
            <Text style={[styles.cell, styles.cellItem]}>{row.uniformNo}</Text>
            <Text style={[styles.cell, styles.cellItem]}>{row.jerseySize}</Text>
            <Text style={[styles.cell, styles.cellItem]}>{row.pantSize}</Text>
            <Text style={[styles.cell, styles.cellItem]}>{row.helmetSize}</Text>
            <Text style={[styles.cell, styles.lastCell, styles.cellItem]}>{row.inseam}</Text>
          </View>
        ))}
    </View>
  </>
);

export default PlayerRosterTable;
